<app-lead-magnet-active-campaign
    [entry]="entry()"></app-lead-magnet-active-campaign>
